export default __webpack_public_path__ + "static/media/leg-icon-transport.c217e31f.png";